{
  "accessories": {
    "winter": [
      {
        "id": 150,
        "img": "https://content.rozetka.com.ua/goods/images/big/251034765.jpg",
        "name": "Шолом HEAD Varius Black",
        "price": 3399,
        "description": "Відмінна риса шолома - екстремально мала вага і наявність активної вентиляції з регулюванням. Шолом виконаний за технологією гарячого пресування In-Mold, коли спінений EPS вдується у зовнішній шар захисного полікарбонату і застигає разом з ним, рахунок чого утворюється монолітна конструкція, що забезпечує чудовий захист при мінімальній вазі. Також шолом відмінно підходить для катання за морозної погоди, тому що верхні вентиляційні отвори легко закриваються одним рухом руки."
      },
      {
        "id": 151,
        "img": "https://content.rozetka.com.ua/goods/images/big/251033754.jpg",
        "name": "Шолом HEAD Compact W White",
        "price": 2699,
        "description": "Жіночий гірськолижний шолом Head Compact W - найбюджетніша модель в колекції HEAD 2022. У її комплектацію входить просунута нова система Sphere Fit Auto - унікальне регулювання, що дозволяє автоматично центрувати шолом точно по маківці голови, що дає зручну посадку шолома і високий рівень комфорту. Sphere Fit Auto замість традиційного коліщатка BOA регулювання має ззаду зручний перемикач розміру на 3 позиції. Компактний, зручний, легкий та доступний шолом із гарним захистом."
      },
      {
        "id": 152,
        "img": "https://cycleshop.com.ua/uploads/catalog/products/additionals/BERN-HEIST-MENS-BRIM-SATIN-BLUE-BLACKLINER-2018.jpg",
        "name": "Шолом BERN Heist Men's Brim",
        "price": 6150,
        "description": "Вдосконалений запатентований фірмовий наповнювач Zip Mold із нижнім шаром із PVC. Кріплення-тримач для маски, стандартний для всіх моделей, 16 невеликих повітряних каналів, через які повітря потрапляє спереду шолома, а виходить ззаду, продуваючи його повністю."
      },
      {
        "id": 153,
        "img": "https://cycleshop.com.ua/uploads/catalog/products/generals/18-19-bern-weston-peak-1-2.jpg",
        "name": "Шолом Bern WESTON PEAK Unisex",
        "price": 4960,
        "description": "Наповнення легким матеріалом Zipmold, який утворює єдиний захисний шар для оптимального балансу міцності та легкості шолома. Регулювання за об'ємом Premium BOA"
      },
      {
        "id": 154,
        "img": "https://dakine-shop.com.ua/files.php?file=upload/image/products/0110568.jpg",
        "name": "Рукавички для лиж / сноуборду жіночі DAKINE Wristguard Glove",
        "price": 2899,
        "description": "DK Dry- це водостійка, вітрозахищена та паропроникна мембрана високої якості, яка розроблена компанією DAKINE. Зверху розташовано два рівня водонепроникної та повітропроникної верхньої плівки для захисту тканин."
      },
      {
        "id": 155,
        "img": "https://dakine-shop.com.ua/files.php?file=upload/image/products/thumb_share/0111409.jpg",
        "name": "Рукавички для лиж / сноуборду чоловічі DAKINE Impreza Gore-tex",
        "price": 2999,
        "description": "Impreza Gore-Tex Glove – це чо­ловічі ру­кавич­ки, які вва­жа­ють­ся од­ни­ми з най­кра­щих се­ред асор­ти­мен­ту Dakine та не ма­ють гідних кон­ку­рентів навіть се­ред інших ви­роб­ників. Прек­расно підхо­дять для за­нять зи­мови­ми ви­дами спор­ту, а та­кож підій­дуть для ви­корис­тання у місь­ко­му житті. Іде­аль­не співвідно­шен­ня ціни та якості, то­му не змо­жуть за­лиши­ти вас бай­ду­жим."
      },
      {
        "id": 156,
        "img": "https://dakine-shop.com.ua/files.php?file=upload/image/products/thumb_share/0106156.jpg",
        "name": "Рукавички для лиж / сноуборду чоловічі DAKINE Crossfire Glove",
        "price": 1500,
        "description": "DAKINE Crossfire Glove - оригінальні ру­кавич­ки для за­нять зи­мови­ми ви­дами спор­ту. Зовнішнім ма­теріалом є ней­лон з поліес­те­ром з во­донеп­ро­ник­ним пок­риттям DWR. До­лоня пок­ри­та син­те­тич­ною зам­шею з силіко­новою встав­кою. Фіксо­вана три­котаж­на підклад­ка. Про­гумо­вані ман­же­ти. На ве­лико­му пальці ру­кави­чок зам­шеві на­шив­ки для сти­ран­ня снігу з мас­ки."
      },
      {
        "id": 157,
        "img": "https://extremstyle.ua/storage/products/22265102003_1.jpg",
        "name": "Маска ANON WM3 MFI W/SPR",
        "price": 12000,
        "description": "Маски Anon WM3 привносять широке поле огляду та низькопрофільний стиль сучасної циліндричної лінзи в нову жіночу оправу, що підходить для невеликих осіб."
      },
      {
        "id": 158,
        "img": "https://extremstyle.ua/storage/products/235781.jpg",
        "name": "Маска ANON M4S TORIC",
        "price": 14000,
        "description": "ОписТоричні маски Anon M4 забезпечують точне прилягання шолома до окулярів з широким полем зору та покращеним периферійним зором торичних лінз. Наша інноваційна технологія швидкої зміни лінз MAGNA-TECH® використовує потужні магніти, щоб зробити заміну лінз простіше, ніж будь-коли. M4 пропонує безпрецедентну гнучкість перемикання між торичними та циліндричними лінзами."
      },
      {
        "id": 159,
        "img": "https://extremstyle.ua/storage/products/22265102003_1.jpg",
        "name": "Маска ANON RELAPSE JR MFI",
        "price": 4700,
        "description": "Лижна маска Oakley Line Miner з найвищим кутом для циліндричних лінз. Дизайн RIM дозволяє носити діоптричні окуляри. Лінс плутоніт забезпечує захист від УФ. Технологічні лінзи HDDO® Lens мають високу оптичну якість, додаткове покриття, яке зменшує механічний збиток."
      },
      {
        "id": 160,
        "img": "https://unisport.ua/content/images/37/931x457l80mc0/maska-gornolyzhnaja-oakley-line-miner-0oo7070-os-cvet--oo7070-14-16541322981081.webp",
        "name": "Маска гірськолижна Oakley LINE MINER",
        "price": 6360,
        "description": "Дитячі маски Anon Relapse Jr. Goggles оснащені нашою ексклюзивною магнітною інтеграцією з маскою для обличчя (MFI®), яка забезпечує повний захист від снігу, вітру та сонця при використанні з нашими сумісними каптурами та масками для обличчя."
      },
      {
        "id": 161,
        "img": "https://unisport.ua/content/images/12/799x459l80mc0/maska-gornolyzhnaja-oakley-line-miner-oo7070-55-26191652874565.webp",
        "name": "Маска гірськолижна Oakley LINE MINER ",
        "price": 4022,
        "description": "Гірськолижна маска Oakley Line Miner з максимально широким кутом огляду для циліндричних лінз. Конструкція оправи дозволяє носити діоптричні окуляри. Матеріал лінз Plutonite забезпечує захист від УФ. Лінзи з технологією HDO® Lens Technology мають високий оптичним якістю, додатковим покриттям, що знижує механічні пошкодження."
      }
    ],
    "summer": [
      {
        "id": 162,
        "img": "https://veloplaneta.ua/resize_491x277x80/upload/iblock/805/6875aa9d-132b-11e3-8487-a949c35f59f2_1685afa3-24fa-11eb-981a-834758a193ec.webp",
        "name": "Комплект крил Topeak DeFender FX/RX",
        "price": 1240,
        "description": "Комплект крил Topeak DeFender FX/RX розроблений спеціально для установки на гірські велосипеди з діаметром коліс 26\". Монтується швидко і легко."
      },
      {
        "id": 163,
        "img": "https://veloplaneta.ua/resize_491x277x80/upload/iblock/354/2c313bec-be1a-11eb-981e-91849d9d8856_26d16bb4-c9dd-11eb-981f-e8835ca6ad66.webp",
        "name": "Крила SKS X-BOARD BLACK/GREY",
        "price": 653,
        "description": "Комплект крил SKS X-BOARD BLACK/GREY розроблений спеціально для установки на гірські велосипеди з діаметром коліс 29\". Монтується швидко і легко."
      },
      {
        "id": 164,
        "img": "https://veloplaneta.ua/resize_491x277x80/upload/iblock/4ba/21952a43-1721-11ed-9826-9b1741e0869d_adc5151c-3da5-11ed-9827-8d1273a5af71.webp",
        "name": "Велокомп`ютер VDO M2.1 WR",
        "price": 1050,
        "description": "Велокомп'ютер VDO M2.1 WR з базовими функціями. Має монохромний дисплей, дротове підключення та захист від вологи IPX4."
      },
      {
        "id": 165,
        "img": "https://veloplaneta.ua/resize_491x277x80/upload/iblock/4d9/ccedbd67-ca7a-11ea-9815-dd7494a0aa95_f89ba7ba-6ab8-11eb-981b-909c4f36594b.webp",
        "name": "Замок U-подібний Onguard Brute LS",
        "price": 1760,
        "description": "U-подібний замок Onguard Brute LS має набагато вищий ступінь захисту в порівнянні з кабельними або ланцюговими велозамками, оскільки дуга виготовляється з особливо міцного металу. Завдяки компактності замок можна розташувати так, що до нього складно добратися болторізом. У замку застосована технологія X4P, яка блокує сталевий затвор з чотирьох сторін штока — система витримає навантаження, якщо замок спробують розламати."
      },
      {
        "id": 166,
        "img": "https://veloplaneta.ua/resize_491x277x80/upload/iblock/262/8f89ed34-be19-11eb-981e-91849d9d8856_ee647437-c9dc-11eb-981f-e8835ca6ad66.webp",
        "name": "Замок U-подібний ABUS 58/140HBIII100 GRANIT Power",
        "price": 5718,
        "description": "18 рівень. 100 х 84 x 18 мм, 1823 г. Циліндр ABUS X-Plus. Кріплення на підніжку SH58 доступне окремо."
      },
      {
        "id": 167,
        "img": "https://veloplaneta.ua/resize_491x277x80/upload/iblock/bb5/fab2e702-7d9e-11eb-981b-909c4f36594b_41358164-9855-11eb-981b-909c4f36594b.webp",
        "name": "Фара передня Lezyne MINI DRIVE",
        "price": 1520,
        "description": "Потужна передня фара Lezyne MINI DRIVE — відмінний вибір для безпечної їзди в темний час доби. Зрізи з боків корпусу забезпечують хорошу бічну видимість."
      },
      {
        "id": 168,
        "img": "https://veloplaneta.ua/resize_491x277x80/upload/iblock/de1/627661e8-04f0-11ed-9826-9b1741e0869d_57b145a1-32b6-11ed-9827-8d1273a5af71.webp",
        "name": "Фара передня Lezyne MINI DRIVE",
        "price": 1520,
        "description": "Потужна передня фара Lezyne MINI DRIVE — відмінний вибір для безпечної їзди в темний час доби. Зрізи з боків корпусу забезпечують хорошу бічну видимість."
      },
      {
        "id": 169,
        "img": "https://veloplaneta.ua/resize_491x277x80/upload/iblock/79f/627661ea-04f0-11ed-9826-9b1741e0869d_57b14584-32b6-11ed-9827-8d1273a5af71.webp",
        "name": "Блимавка задня Lezyne STRIP DRIVE PRO REAR",
        "price": 2360,
        "description": "Компактна і потужна задня блимавка Lezyne STRIP DRIVE PRO REAR буде універсальним вибором як для поїздок у місті, так і поза ним. Має 11 режимів, тому можна вибрати необхідний відповідно до будь-якої ситуації."
      },
      {
        "id": 170,
        "img": "https://veloplaneta.ua/resize_491x277x80/upload/iblock/62f/627661ed-04f0-11ed-9826-9b1741e0869d_5db2af0e-32b6-11ed-9827-8d1273a5af71.webp",
        "name": "Блимавка задня Lezyne ZECTO DRIVE REAR",
        "price": 1720,
        "description": "Компактна блимавка Lezyne ZECTO DRIVE MAX REAR з трьома яскравими світлодіодами, що забезпечують відмінну видимість для поїздок у місті. Має 8 режимів, тому можна вибрати необхідний відповідно до будь-якої ситуації."
      },
      {
        "id": 171,
        "img": "https://veloplaneta.ua/resize_491x277x80/upload/iblock/b73/d6b156a1-62e4-11e6-a059-e890d310d3e3_e8fad66b-2a85-11e7-b910-a5861d6170f6.webp",
        "name": "Фляготримач Green Cycle GGE-112",
        "price": 152,
        "description": "Фляготримач Green Cycle GGE-112 виготовлений з надійного і довговічного алюмінію. Конструкція щільно утримує флягу на місці і в той же час дозволяє її без зусиль дістати."
      }
    ]
  }
}
